/* jshint loopfunc:true */
import React, { Fragment } from 'react'
import * as Logger from 'loglevel'
import {
  Row,
  Col,
  Table,
  Collapse,
  Tab,
  Tabs,
  Card, //,
  OverlayTrigger,
  Tooltip
} from 'react-bootstrap'
// import * as APIContentFetcher from './util/APIContentFetcher'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Utilities, { UtilConstant } from 'hub-utilities'
import * as BrowserDetector from './util/BrowserDetector'
import { faDownload, faFileExport, faLock } from '@fortawesome/free-solid-svg-icons'
import MediaContent from './tools/MediaContent'
// import authService from '../../api-authorization/AuthorizeService';
import {TableRowAction} from './DataTable'
import ClipLoader from 'react-spinners/ClipLoader'
import { css } from '@emotion/core'
import '../styles/CollapsibleRow.scss'

export const CollapsibleRowType = Object.freeze({
  REGULAR: 0,
  WHOLE_COL_RIGHT: 1, // Whole_col_right takes up the column in the right hand side, by 30%
  PARAGRAPH: 2 // Paragraph takes up the whole 2 bottom rows
})

class CollapsibleRow extends React.Component {
  _isMounted = false // for some weird reason, setState is called in componentDidMount while unmounting
  constructor(props) {
    super(props)
    this.state = {
      errorMsg: ''
    }
  }

  componentWillUnmount() {
    this._isMounted = false
  }

  AdjustTextareaHeight = (e) => {
    e.target.style.height = 'inherit'
    e.target.style.height = `${e.target.scrollHeight}px`
    // In case you have a limitation
    // e.target.style.height = `${Math.min(e.target.scrollHeight, limit)}px`;
  }

  deleteNullData(data) {
    var processedData = []
    for (var i = 0; i < data.length; i++) {
      if (!(data[i].hideIfNull == null || data[i].hideIfNull === undefined)) {
        processedData.push(data[i])
      }
    }
    return processedData
  }

  getTextHref(value) {
    var href = null
    var text = `${this.props.title}\r\n\r\n${value}`
    var textFileAsBlob = new Blob([text], { type: 'text/plain' })
    if (BrowserDetector.detectBrowser() === BrowserDetector.BrowserType.IE) {
      // for IE
      // ie doesn't create url blobs due to security reasons
      window.navigator.msSaveOrOpenBlob(textFileAsBlob, text)
      return '/'
    } else {
      href = window.webkitURL.createObjectURL(textFileAsBlob)
    }
    return href
  }

  renderDownloadFile(value, isDataFileIncluded) {
    if (BrowserDetector.detectBrowser() === BrowserDetector.BrowserType.IE) {
      // for IE
      // ie doesn't create url blobs due to security reasons
      return (
        <Fragment>
          <p>&nbsp;</p>
          <p>
            <i>
              Note: IE does not support content downloads. Please use Chrome or
              Firefox for more functionalities.
            </i>
          </p>
        </Fragment>
      )
    } else {
      if (!!value && isDataFileIncluded) {
        return (
          <a
            href={this.getTextHref(value)}
            download={Utilities.buildDownloadFileName(this.props.title, 'txt')}
          >
            <FontAwesomeIcon icon={faDownload} />
          </a>
        )
      }
    }
  }

  // used functions instead of ternary expressions
  renderNonNullRegular(dataObj) {
    return dataObj.val
  }

  renderNonNullParagraph(dataObj) {
    var editingRow = this.props.inPlaceEditingRows.find(
      (editingRow) => editingRow.id === dataObj.hideIfNull
    )
    var editingAttr = null
    if (editingRow)
      editingAttr = editingRow.data.find(
        (dataAttr) => dataAttr.key === dataObj.key
      )
    return (
      <Fragment>
        <p>
          {dataObj.key}: &nbsp;{' '}
          {dataObj.val !== '' ? (
            this.renderDownloadFile(dataObj.val, true)
          ) : (
            <></>
          )}
        </p>
        {dataObj.isEditable ? (
          <div
            contentEditable
            className='innerParagraph transparentTextInput'
            onInput={(e) =>
              this.props.setInPlaceEditingRow(
                dataObj.hideIfNull,
                dataObj.key,
                dataObj.val,
                e.target.innerText
              )
            }
          >
            {/* div instead of textarea for glitch-free autosizing */}
            {!!editingRow && !!editingAttr ? editingAttr.val : dataObj.val}
          </div>
        ) : (
          <p className='innerParagraph'>{dataObj.val}</p>
        )}
      </Fragment>
    )
  }

  insertRightRow(data) {
    const mediaData = data.filter(
      (element) => element.rowType === CollapsibleRowType.WHOLE_COL_RIGHT
    )

    if (mediaData.length > 0) {
      return (
        <td
          key={`RightRow_${data.key}`}
          colSpan={3}
          rowSpan={3}
          valign='center'
          className='collapsedMediaRow'
        >
          <Fragment key={`RightRow_Fragment_ErrorMsg_${data.key}`}>
            {this.state.errorMsg ? (
              <div className='errorMsg'>{this.state.errorMsg}</div>
            ) : (
              <Fragment />
            )}
          </Fragment>
          <Fragment key={`RightRow_Fragment_val_${data.key}`}>
            {mediaData.map((mediaDataObj, index) => {
              return (
                <MediaContent
                  key={`mediaContent${index}`}
                  className='MediaContent'
                  elementId={mediaDataObj.elementId}
                  contentType={mediaDataObj.contentType}
                  mediaFetchUrl={mediaDataObj.mediaFetchUrl}
                  elementName={mediaDataObj.elementName}
                  mimeType={mediaDataObj.mimeType}
                  outQ={mediaDataObj.outQ}
                  verbatim={mediaDataObj.verbatim}
                  onPreviewMedia={this.props.collapsibleData.onPreviewMedia}
                  onDownloadMedia={this.props.collapsibleData.onDownloadMedia}
                  onEditOutQ={this.props.collapsibleData.onEditOutQ}
                />
              )
            })}
          </Fragment>
        </td>
      )
    } else return <Fragment key='NoRightRow_Fragment_ErrorMsg' />
  }

  // async function causes react unable to fetch data properly --> use react-async --> problem solved
  insertAttribute(maxColsPerRow, data) {
    var colPerRowCounter = 0
    var tdArray = []
    var trArray = []
    var nonNullData = this.deleteNullData(data)

    var isFirstRowInserted = false
    for (var i = 0; i < nonNullData.length; i++) {
      if (
        !!nonNullData[i].metadataId &&
        !!this.props.collapsibleData.metadata
      ) {
        colPerRowCounter += nonNullData[i].colsOccupied

        var mdata = this.props.collapsibleData.metadata.find(
          (mdata) => mdata.fieldId === nonNullData[i].metadataId
        )
        if (mdata) {
          tdArray.push(
            <td
              key={`collapsible_attr${i}_${this.props.id}`}
              colSpan={nonNullData[i].colsOccupied}
              style={{ whiteSpace: 'pre-wrap' }}
              className={`${nonNullData[i].isUrgency ? 'urgentText' : ''} ${
                nonNullData[i].isUrgencyVal ? 'urgentValText' : ''
              }`}
            >
              {this.renderNonNullRegular({
                ...(!!nonNullData[i].isMetadataName && {
                  val: mdata ? mdata.fieldName + ':' : ''
                }),
                ...(!!nonNullData[i].isMetadataVals && {
                  val: mdata
                    ? mdata.values
                        .map((value) => {
                          return Utilities.verifyDataHasCorrectDataType(
                            value.value,
                            UtilConstant.HUB_DATA_TYPE.DATETIME
                          )
                            ? Utilities.formatObjectDate(
                                value.value + '.000Z',
                                UtilConstant.HUB_TIME_FORMAT.CANADIAN,
                                true
                              )
                            : value.value
                        })
                        .join(', ')
                    : 'None'
                })
              })}
            </td>
          )
        } else {
          tdArray.push(
            <td
              key={`collapsible_attr${i}_${this.props.id}`}
              colSpan={nonNullData[i].colsOccupied}
              style={{ whiteSpace: 'pre-wrap' }}
              className={`${nonNullData[i].isUrgency ? 'urgentText' : ''} ${
                nonNullData[i].isUrgencyVal ? 'urgentValText' : ''
              }`}
            />
          )
        }

        if (colPerRowCounter >= maxColsPerRow) {
          // for the first row, loop over the non-null data and insert the right long row if necessasry:
          if (!isFirstRowInserted) {
            const rightRow = this.insertRightRow(nonNullData)
            if (rightRow != null) {
              tdArray.push(rightRow)
              isFirstRowInserted = true
            }
          }

          // push to the row array
          trArray.push(
            <tr key={`collapsible_attr_tr${i}_${this.props.id}`}>{tdArray}</tr>
          )
          tdArray = []
          colPerRowCounter = 0
        }
      } else {
        switch (nonNullData[i].rowType) {
          case CollapsibleRowType.REGULAR:
            colPerRowCounter += nonNullData[i].colsOccupied
            // Push the table data
            tdArray.push(
              <td
                key={`collapsible_attr_attr_tr_regular_${i}_${this.props.id}`}
                colSpan={nonNullData[i].colsOccupied}
                style={{ whiteSpace: 'pre-wrap' }}
                className={`${nonNullData[i].isUrgency ? 'urgentText' : ''} ${
                  nonNullData[i].isUrgencyVal ? 'urgentValText' : ''
                }`}
              >
                {this.renderNonNullRegular(nonNullData[i])}
              </td>
            )

            if (colPerRowCounter >= maxColsPerRow) {
              // for the first row, loop over the non-null data and insert the right long row if necessasry:
              if (!isFirstRowInserted) {
                const rightRow = this.insertRightRow(nonNullData)
                if (rightRow != null) {
                  tdArray.push(rightRow)
                  isFirstRowInserted = true
                }
              }

              // push to the row array
              trArray.push(
                <tr key={`collapsible_attr_tr_regular_${i}_${this.props.id}`}>
                  {tdArray}
                </tr>
              )
              tdArray = []
              colPerRowCounter = 0
            }

            break
          case CollapsibleRowType.WHOLE_COL_RIGHT:
            break

          case CollapsibleRowType.PARAGRAPH:
            if (tdArray.length > 0) {
              // if there are existing table data already, push... so that this won't get affected
              trArray.push(
                <tr key={`paragraph_tr_paragraph_${i + 1}_${this.props.id}`}>
                  {tdArray}
                </tr>
              )
              tdArray = []
              colPerRowCounter = 0
            }
            // trArray.push(<tr><td colSpan={maxColsPerRow}>{nonNullData[i].key}</td></tr>);

            trArray.push(
              <tr
                key={`paragraph_tr_paragraph_${i}_${this.props.id}`}
                className='paragraphRow'
              >
                <td
                  key={`paragraph_td_paragraph_${i}_${this.props.id}`}
                  colSpan={maxColsPerRow}
                >
                  <Fragment>
                    {this.renderNonNullParagraph(nonNullData[i])}
                  </Fragment>
                </td>
              </tr>
            )

            break

          default:
            break
        }
      }
    }
    if (tdArray.length > 0) {
      trArray.push(
        <tr key={`tr_wrapper_collapsible_${this.props.id}`}>{tdArray}</tr>
      )
    }
    return trArray
  }

  renderMetadata(metadata) {
    return (
      <Row>
        <Col xs='12'>
          {metadata.map((mdata, index) => {
            return (
              <p key={`AboutInfo${index}`} className='AboutInfo'>
                <span>
                  <b>{mdata.fieldName}:</b>&nbsp;
                </span>
                {mdata.values
                  .map((value) => {
                    return Utilities.verifyDataHasCorrectDataType(
                      value.value,
                      UtilConstant.HUB_DATA_TYPE.DATETIME
                    )
                      ? Utilities.formatObjectDate(
                          value.value + '.000Z',
                          UtilConstant.HUB_TIME_FORMAT.CANADIAN,
                          true
                        )
                      : value.value
                  })
                  .join(', ')}
              </p>
            )
          })}
        </Col>
      </Row>
    )
  }

  // downloadAll = async (event) => {
  //   event.preventDefault()
  //   this.setState({ errorMsg: '' })
  //   var blobInfo = await APIContentFetcher.fetchMediaZipInfo(
  //     this.props.collapsibleData.id,
  //     this.props.authorizeService.getAccessTokenAsync()
  //   )
  //   if (blobInfo.error) {
  //     this.setState({ errorMsg: blobInfo.error })
  //   } else {
  //     var temporaryDownloadLink = document.createElement('a')
  //     temporaryDownloadLink.style.display = 'none'
  //     document.body.appendChild(temporaryDownloadLink)

  //     temporaryDownloadLink.setAttribute('href', blobInfo.url)
  //     temporaryDownloadLink.setAttribute('download', blobInfo.name)

  //     temporaryDownloadLink.click()

  //     document.body.removeChild(temporaryDownloadLink)
  //   }
  // }

  // renderDownloadAllIcon() {
  //   var downloadableData = this.props.collapsibleAPIData.val.filter(
  //     (elem) => elem.rowType === CollapsibleRowType.WHOLE_COL_RIGHT
  //   )

  //   if (!!downloadableData && downloadableData.length > 0) {
  //     return (
  //       <OverlayTrigger
  //         key='downloadAll_allRow'
  //         placement='bottom'
  //         overlay={
  //           <Tooltip>
  //             Download{' '}
  //             {this.props.activeTableName
  //               ? this.props.activeTableName.singular.split(' ').join('\n')
  //               : this.props.activePageName
  //               ? this.props.activePageName.singular.split(' ').join('\n')
  //               : ''}
  //           </Tooltip>
  //         }
  //       >
  //         <a
  //           className='downloadAll'
  //           href='#'
  //           onClick={(e) => this.downloadAll(e)}
  //         >
  //           <img src='images/download-all-icon.png' />
  //         </a>
  //       </OverlayTrigger>
  //     )
  //   }
  //   return <Fragment />
  // }

  renderLoader() {
    const collapsibleLoaderOverride = css`
      position: absolute;
      top: 12px;
      right: 20px;
    `
    return (
      <ClipLoader
        size={20}
        color='black'
        loading={this.state.loading}
        css={collapsibleLoaderOverride}
      />
    )
  }

  render() {
    var moveFolderRowAction = this.props.dataObj.rowActions.find(
      (action) =>
        action.action === TableRowAction.MOVE_FOLDER_ROW &&
        (!this.props.folderPermissions || ((this.props.folderPermissions & action.userPermission) === action.userPermission))
    )
    return (
      <tr
        key={`collapsible_tr_${this.props.index}`}
        className={`${
          this.props.index % 2 === 0
            ? 'oddRow collapsibleRow'
            : 'evenRow collapsibleRow'
        } ${
          this.props.isUrgent !== undefined && this.props.isUrgent
            ? 'urgent'
            : ''
        }`}
      >
        <td
          key={`collapsible_td_${this.props.index}`}
          colSpan={this.props.numOfTableCols}
          className='collapsibleData'
        >
          {' '}
          {/* div warpper in collapse
              to prevent glitchy animation */}
          <Collapse
            in={this.props.isNotCollapsed}
            className={
              this.props.isCollapsedAnimDisabled ? 'disableCollapsing' : ''
            }
          >
            <div>
              <div className='tableExternalSpaces'>
                <Card className='HubInfoCard HubDetailCard'>
                  <Card.Body>
                    <Tabs
                      id='controlled-tab-example'
                      defaultActiveKey='additionalInfo'
                    >
                      <Tab
                        eventKey='additionalInfo'
                        title={`${
                          this.props.activeTableName
                            ? this.props.activeTableName.singular
                                .split(' ')
                                .join('\n')
                            : this.props.activePageName
                            ? this.props.activePageName.singular
                                .split(' ')
                                .join('\n')
                            : ''
                        } Details`}
                      >
                        <Table striped bordered>
                          <tbody>
                            {this.insertAttribute(
                              this.props.collapsibleData.numOfColsPerRow,
                              this.props.collapsibleData.data
                            )}
                          </tbody>
                        </Table>
                      </Tab>
                      {this.props.collapsibleData.metadata ? (
                        <Tab eventKey='storyData' title='Extra Data'>
                          {this.renderMetadata(
                            this.props.collapsibleData.metadata.filter(
                              (mdata) => mdata.fieldId !== 1
                            )
                          )}
                        </Tab>
                      ) : (
                        <Fragment />
                      )}
                    </Tabs>
                  {!!moveFolderRowAction ?
                      (<OverlayTrigger
                          key={`moveStory_${this.props.dataObj.id}`}
                          placement='bottom'
                          overlay={
                              <Tooltip className='rowActionTooltip' style={{ paddingLeft: '40px' }}>
                                  {moveFolderRowAction.isLocked ? `Locked by ${moveFolderRowAction.lockUserName}` : 'Move Story'}
                              </Tooltip>
                          }
                      >
                          <td
                              key={`move_${this.props.dataObj.id}`}
                              className={`moveStory ${moveFolderRowAction.isLocked ? 'disabled disabledWithTooltip' : ''}`}
                              onClick={!moveFolderRowAction.isLocked ? (e) => {
                                  this.props.onRowAction(e, TableRowAction.MOVE_FOLDER_ROW, this.props.data, this.props.index)
                                  const nextObj = {
                                      ...this.props.dataObj,
                                      isFullTextSearchActive: this.props.isFullTextSearchActive
                                  }
                                  this.props.onOpenForm(moveFolderRowAction.form, moveFolderRowAction.action, nextObj)
                              } : null}
                          >
                              <FontAwesomeIcon icon={moveFolderRowAction.isLocked ? faLock : faFileExport} />
                          </td>
                      </OverlayTrigger>) : <Fragment />}
                  </Card.Body>
                </Card>
              </div>
            </div>
          </Collapse>
        </td>
      </tr>
    )
  }
}

export default CollapsibleRow
